<template>
  <ProgressNav>
    <ProgressNavList>
      <ProgressNavItem
        v-for="(step, index) in steps"
        :key="index"
        :active="signupStep === index + 1"
        :available="step.isAvailable"
        :disabled="!step.isAvailable"
        class="mx-1"
        @click="handleStepClick(index + 1)"
      >
        <span class="me-2"> {{ index + 1 }}.</span>
        <span>
          {{ step.title }}
        </span>
      </ProgressNavItem>
    </ProgressNavList>
  </ProgressNav>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import type { Step } from "@/types";
import {
  ProgressNav,
  ProgressNavList,
  ProgressNavItem,
} from "@/signup/progress-nav";

const props = defineProps<{
  steps: Step[];
  setStep: (step: number) => void;
}>();

const route = useRoute();
const signupStep = computed(() => {
  const step = parseInt(route.query.step as string);
  return Number.isNaN(step) ? 1 : step;
});

const handleStepClick = (step: number) => {
  if (props.steps[step - 1] === null) {
    return;
  }
  if (props.steps[step - 1] && props.steps[step - 1].isAvailable) {
    props.setStep(step);
  }
};
</script>
